// Gestion utile des calculs
// Contient l'ajustement (en pourcentage)
// La correction du nombre de chiffres après la virgule, ...

export const inPercentage = (val) => {
    return val * 100
}

/** Permet d'ajuster le nombre de chiffres après la virgule */
export const adjust = (val, numbers) => {
    const value = parseFloat(val)
    return parseFloat(value.toFixed(numbers))
}

/** Permet de réduire un tableau à une seule ligne dont les valeurs sont les plus proches des valeurs fournies */
export const closest = (array = [], field, value) => {
    return array.reduce((prev, curr) => {
        return Math.abs(curr[field] - value) < Math.abs(prev[field] - value) ? curr : prev
    })
}